module.exports = __webpack_public_path__ + "img/microplastics-process-6-mobile.c582e1fa.png";